// extracted by mini-css-extract-plugin
export default {"textbox":"TextBox_textbox__x3wVz","textbox2":"TextBox_textbox2__TmbSn"};